/* eslint-disable @angular-eslint/component-selector */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardTitle } from '@angular/material/card';
import { PromotionListItem } from '@idealsupply/ngclient-webservice-inventory';

@Component({
  selector: 'product-promo-card-list-item',
  templateUrl: './promo-card-list-item.component.html',
  styleUrls: ['./promo-card-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardImage, MatCardContent],
})
export class PromoCardListItemComponent {
  @Input()
  public promo: PromotionListItem | undefined;
}
